import React from 'react';
import PropTypes from 'prop-types';
import styles from './ProgressBar.module.scss.js';

function ProgressBar(_ref) {
  var progress = _ref.progress;
  return /*#__PURE__*/React.createElement("section", {
    className: styles.progressBarContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.progressBar,
    style: {
      width: "".concat(progress, "%")
    }
  }));
}
ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired
};

export { ProgressBar as default };
